{
    "stats_block_title__recommendation_count": "Nombre d'alertes d'attrition",
    "stats_block_title__customer_count": "Clients avec alertes d'attrition",
    "stats_block_title__total_loss": "Perte potentielle de chiffre d'affaires",
    "state_block_detail__vs_last_period": "par rapport à la période précédente",

    "note_body": "Si vous créez une tâche pour une recommandation commerciale, celle-ci disparaîtra de cette vue",

    "insight_table__header_insight_generated_at": "Généré le",
    "insight_table__header_customer": "Client",
    "insight_table__header_product_group": "Groupe d'articles",
    "insight_table__header_ttm_delta": "Écart de CA sur 12 mois",
    "insight_table__header_sales_last_24_months": "CA des 24 derniers mois",
    "insight_table__header_orders_last_24_months": "Commandes des 24 derniers mois",
    "insight_table__header_reason": "Motif",
    "insight_table__header_sales_rep": "Commercial",

    "search_placeholder__customers": "Rechercher des clients"
}
